import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { PerformanceDashboard } from './components/PerformanceDashboard';
export function App() {
  const [activeTab, setActiveTab] = useState('service-performance');
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-0">
      <Sidebar activeItem="performance" data-id="element-1" />
      <PerformanceDashboard activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-2" />
    </div>;
}